import { j as o } from "../../../../jsx-runtime-BwWtxLpl.js";
import "react";
import e from "prop-types";
import a from "classnames";
import { IconoirCheck as d, IconoirMinus as f } from "@ey-xd/motif-icon";
import { MotifIcon as i } from "../../../icon/icon.js";
import "../../../icon/icon.context.js";
const p = (s) => {
  const { selected: n = !1, icons: c = {}, indeterminate: l = !1, onClick: t = null } = s, m = a({
    "motif-select-checkbox": !0,
    "motif-select-checkbox-selected": n,
    "motif-select-checkbox-indeterminate": l
  }), r = () => {
    t && t();
  };
  return /* @__PURE__ */ o.jsxs("div", { className: m, onClick: r, children: [
    c.selected || /* @__PURE__ */ o.jsx(i, { iconFunction: d, className: "motif-select-checkbox-icon-selected" }),
    c.indeterminate || /* @__PURE__ */ o.jsx(i, { iconFunction: f, className: "motif-select-checkbox-icon-indeterminate" })
  ] });
};
p.propTypes = {
  selected: e.bool,
  icons: e.shape({
    selected: e.node,
    indeterminate: e.node
  }),
  indeterminate: e.bool,
  onClick: e.func
};
export {
  p as SelectCheckbox
};
